/**
 * Bundle design mock registry.
 *
 * Maps each mock design ID to the raw API array that `designsTransformer`
 * expects.  Referenced by the mock branch in `tryGetMultipleDesigns`.
 *
 * Add new entries here when creating additional bundle mocks.
 */
import wallStorageMock from './wallStorage-bundle.mock';
import vehicleStorageMock from './vehicleStorage-bundle.mock';
import vehicleStorageHardbundleMock from './vehicleStorage-hardbundle.mock'
import wallStorageLoadedMock from './wallStorage-bundle-loaded.mock';
import ryobiWallRailBundleMock from './ryobi-wallRail-bundle.mock';
import ryobiWallRailWithEndcapsBundleMock from './ryobi-wallRail-with-endcaps-bundle.mock';
import ryobiEndcapsOnlyBundleMock from './ryobi-endcaps-only-bundle.mock';
import wallStorageIsbSingleWireShelfMock from './wallStorage-isb-singleWireShelf.mock';
import wallStorageIsbSingleSolidShelfMock from './wallStorage-isb-singleSolidShelf.mock';
import wallStorageIsbDoubleWireShelfMock from './wallStorage-isb-doubleWireShelf.mock';
import wallStorageIsbDoubleSolidShelfMock from './wallStorage-isb-doubleSolidShelf.mock';
/**
 * @type {Record<string, import('../../src/api/design/bundleDesign.types').BundleDesignApiResponse[]>}
 */
const MOCK_BUNDLE_DESIGNS = {
  // WallStorage – 2-plate horizontal bundle (6 cols × 1 row)
  '8f0af0eb-0000-0000-0000-mock00000001': wallStorageMock,

  // VehicleStorage – Rack + Frame bundle with null-SKU drawers
  '15a265db-0000-0000-0000-mock00000002': vehicleStorageMock,

  // VehicleStorage - HardBundle
  '15a265db-0000-0000-0000-mock00000003': vehicleStorageHardbundleMock,

  // WallStorage – 2-plate bundle loaded with rack, cabinet, organizer & hooks
  '8f0af0eb-0000-0000-0000-mock00000004': wallStorageLoadedMock,

  // WallStorage – Ryobi Wall Rail 2-pack single-SKU bundle
  '8f0af0eb-0000-0000-0000-mock00000006': ryobiWallRailBundleMock,

  // WallStorage – Ryobi Wall Rail + End Caps single-SKU bundle
  '8f0af0eb-0000-0000-0000-mock00000007': ryobiWallRailWithEndcapsBundleMock,
  '8f0af0eb-0000-0000-0000-mock00000008': ryobiEndcapsOnlyBundleMock,

  // WallStorage – inseparable soft bundle (ISB) choices (FSI-6375): each resolves to N
  // brackets + shelves (2 brackets + 1 shelf for Single*, 3 brackets + 2 shelves for
  // Double* — reusing the same shelf part twice, not a wider shelf) that stay
  // permanently grouped by bundleInstanceId after placement, rather than collapsing
  // into one packaged single-SKU unit.
  '8f0af0eb-0000-0000-0000-mock00000011': wallStorageIsbSingleWireShelfMock,
  '8f0af0eb-0000-0000-0000-mock00000012': wallStorageIsbSingleSolidShelfMock,
  '8f0af0eb-0000-0000-0000-mock00000013': wallStorageIsbDoubleWireShelfMock,
  '8f0af0eb-0000-0000-0000-mock00000014': wallStorageIsbDoubleSolidShelfMock,
};

export default MOCK_BUNDLE_DESIGNS;
